import { IRemoteAudioTrack } from "agora-rtc-sdk-ng"

export function createRemoteAudioPlayback() {
    let track: IRemoteAudioTrack | undefined
    return {
        attach(remoteAudioTrack: IRemoteAudioTrack) {
            track = remoteAudioTrack
        },
        detach() {
            track?.stop()
            track = undefined
        },
        apply({ muted, volumePercent }: { muted: boolean; volumePercent: number }) {
            if (!track) return
            track.setVolume(muted ? 0 : volumePercent)
            if (!muted && !track.isPlaying) {
                track.play()
                track.setVolume(volumePercent)
            }
        },
    }
}
